import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {
	type IAttributeVocabularyValue,
	AttributeVocabularyValueInsert,
} from '../schema';
import {getAttributeVocabularyValues} from './getAttributeVocabularyValues';

/**
 * `addAttributeVocabularyValues` request params
 * (what is used to send to server)
 */

export type AddAttributeVocabularyValueRequestOptions = {
	id: number;
	values: string[];
	valueId?: number;
	beforeOrAfterExistingId?: AttributeVocabularyValueInsert;
};

/**
 * `addAttributeVocabularyValues` request
 * (what gets sent to the server)
 */
export type AddAttributeVocabularyValueRequest = [
	AddAttributeVocabularyValueRequestOptions['id'],
	AddAttributeVocabularyValueRequestOptions['values'],
	Required<AddAttributeVocabularyValueRequestOptions>['valueId'],
	Required<AddAttributeVocabularyValueRequestOptions>['beforeOrAfterExistingId'],
];

/**
 * `addAttributeVocabularyValues` response
 * (what comes back from the server)
 */
export type AddAttributeVocabularyValueResponse =
	SuccessResponse<AddAttributeVocabularyValueResult>;

/**
 * `addAttributeVocabularyValues` result
 * (what is utilized from the server response)
 */
export type AddAttributeVocabularyValueResult = IAttributeVocabularyValue[];

export const addAttributeVocabularyValueEndpoint =
	'addAttributeVocabularyValue';

/**
 * Add attribute vocabularies list
 * @param fetchParams Fetch params

 */
export const addAttributeVocabularyValue = async ({
	id,
	values,
	valueId = 0,
	beforeOrAfterExistingId = 0,
}: AddAttributeVocabularyValueRequestOptions): Promise<AddAttributeVocabularyValueResult> => {
	const client = NetxQueryClient();

	if (valueId < 1) {
		const values = await getAttributeVocabularyValues({id, stopIndex: 1});
		if (values.results.length) valueId = values.results[0].id;
	}

	const requestParams: AddAttributeVocabularyValueRequest = [
		id,
		values,
		valueId,
		beforeOrAfterExistingId,
	];

	return client
		.post<AddAttributeVocabularyValueResponse>(
			addAttributeVocabularyValueEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default addAttributeVocabularyValue;
